import React from 'react';
import {
  LinkStyled, Paragraph,
} from '../../typography';
import { PricePrPiece } from '../../../containers/commerce/parts';

export default React.forwardRef((props) => {
  const {
    varenr,
    url,
  } = props;
  return (
    <Paragraph>
      <LinkStyled to={url}>
        Pris pr stk. ved køb af palle: <PricePrPiece varenr={varenr} />
      </LinkStyled>
    </Paragraph>
  );
});
